export const de = {
    translation: {
        b: {
            cancel: 'Abbrechen',
            confirm: 'Bestätigen',
            send: 'Senden',
            done: 'Fertig',
            close: 'Schließen',
            clear: 'Leeren',
            copy_link: 'Link kopieren',
            export: 'Exportieren',
            delete: 'Löschen',
            delete_confirm: 'Löschen bestätigen',
            duplicate: 'Duplizieren',
            share: 'Teilen',
            sign_in: 'Anmelden',
            sign_up: 'Registrieren',
            email_address: 'E-Mail-Adresse',
            yes: 'Ja',
            no: 'Nein',
            back: 'Zurück',
            upgrade: 'Upgraden',
            remove: 'Entfernen',
            restore: 'Wiederherstellen',
            archive: 'Archivieren',
            rename: 'Umbenennen',
            leave: 'Verlassen',
            import: 'Importieren',
            continue: 'Weiter',
            settings: 'Einstellungen',
            log_out: 'Abmelden',
            invite: 'Einladen',
            invited: 'Eingeladen',
        },
        roles: {
            view: 'Betrachter',
            comment: 'Kommentator',
            edit: 'Bearbeiter',
            admin: 'Admin',
            owner: 'Eigentümer',
            member: 'Mitglied',
            remove: 'Entfernen',
            more_roles: 'Weitere Rollen...',
            change_role: 'Rolle ändern...',
            remove_access: 'Zugriff entfernen...',
            remove_invite: 'Einladung entfernen...',
        },
        db_engine: {
            basic: 'Einfaches SQL',
            general: 'Allgemeines SQL',
        },
        socket_status: {
            reconnecting: 'Verbindung wird wiederhergestellt...',
            offline: 'Sie sind offline. Verbindung wird wiederhergestellt...',
        },
        loader: {
            diagram: 'Diagramm wird geladen...',
        },
        m_languages: {
            title: 'Sprachen',
            subtitle: 'Sprache wählen'
        },
        m_feedback: {
            feature: {
                name: 'Feature-Anfragen', // Funktionswunsch
                desc: 'Fehlt Ihnen eine Funktion? Sagen Sie es uns — Ihre Ideen zählen'
            },
            feedback: {
                name: 'Teilen Sie Ihr Feedback',
                desc: 'Wir würden gerne hören, was Sie denken'
            },
            support: {
                name: 'Support',
                desc: 'Funktioniert etwas nicht? Sagen Sie es uns — wir kümmern uns schnell darum',
            },
            bug: {
                name: 'Problem melden',
                desc: 'Etwas stimmt nicht ganz? Melden Sie es — wir kümmern uns schnell darum',
            },
            integration: {
                name: 'Integration anfragen',
                desc: 'Ihr Feedback bedeutet uns viel — hinterlassen Sie eine kurze Nachricht',
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Danke für Ihren Vorschlag!',
                desc: 'Wir schätzen es sehr, dass Sie sich die Zeit nehmen, Ihre Gedanken zu teilen — das hilft uns, besser zu werden.'
            },
            feedback: {
                name: 'Danke für Ihr Feedback!',
                desc: 'Wir schätzen es sehr, dass Sie sich die Zeit nehmen, Ihre Gedanken zu teilen — das hilft uns, besser zu werden.'
            },
            support: {
                name: 'Danke, dass Sie sich gemeldet haben!',
                desc: 'Danke, dass Sie den Support kontaktiert haben — wir prüfen Ihre Anfrage und melden uns so schnell wie möglich.',
            },
            bug: {
                name: 'Danke für Ihre Meldung!',
                desc: 'Danke, dass Sie dies gemeldet haben — das hilft uns, Probleme schneller zu beheben und die Erfahrung stetig zu verbessern.',
            },
            contact: {
                name: 'Danke, dass Sie sich gemeldet haben!',
                desc: 'Wir haben Ihre Nachricht erhalten und melden uns so schnell wie möglich bei Ihnen.',
            },
            invite_people: {
                name: 'Einladung erfolgreich gesendet!',
                desc: 'Danke, dass Sie es weitererzählen — wir freuen uns, sie an Bord zu begrüßen.',
            },
            integration: {
                name: 'Danke für Ihren Vorschlag!',
                desc: 'Wir schätzen es sehr, dass Sie sich die Zeit nehmen, Ihre Gedanken zu teilen — das hilft uns, besser zu werden.',
            },
        },
        m_diagram_details: {
            name_place: 'Projektnamen eingeben',
            desc_place: 'Projektbeschreibung eingeben'
        },
        m_quick_share: {
            title: 'Schnelles Teilen',
            subtitle: '(Teilen per Link)'
        },
        m_export_img: {
            title: 'Bild exportieren'
        },
        search_menu: {
            placeholder: 'Tabellen, Spalten, Typen durchsuchen...',
            hint: '',
            no_results: 'Keine Ergebnisse',
            quick_results: 'Schnelle Ergebnisse für',
            untitled: 'unbenannt',
            command_tag: 'Befehl',
            section_tables: 'Tabellen',
            section_columns: 'Spalten',
            section_canvas: 'Arbeitsfläche',
            section_export: 'Export',
            section_preferences: 'Präferenzen',
            section_settings: 'Einstellungen',
            type_table: 'Tabelle',
            type_note: 'Notiz',
            cmd_new_table: 'Neue Tabelle erstellen...',
            cmd_new_note: 'Neue Notiz erstellen...',
            cmd_new_line: 'Neue Linie erstellen...',
            cmd_new_area: 'Neuen Bereich erstellen...',
            cmd_export_image: 'Bild exportieren...',
            cmd_export_sql: 'SQL-Code exportieren...',
            cmd_grid_style: 'Rasteransicht ändern...',
        },
        canvas_table: {
            more_column: 'weitere Spalte',
            more_columns: 'weitere Spalten',
            tooltip_table: 'Tabelle',
            tooltip_indexes: 'Indizes',
            tooltip_enum: 'Enum',
            tooltip_default: 'Standard',
            tooltip_generated: 'Generiert',
            tooltip_check: 'Check',
        },
        m_export_code: {
            title: 'Code {{db_engine}} exportieren',
            download_file: 'Datei herunterladen',
            copy_code: 'Code kopieren'
        },
        m_sign_in_remind: {
            title: 'Danke, dass Sie DB Design ausprobieren',
            subtitle: 'Melden Sie sich an oder registrieren Sie sich, um das Limit für die Anzahl der Tabellen zu erhöhen, Diagramme zu speichern und weitere Funktionen freizuschalten.'
        },
        m_sign_in_restrict: {
            title: 'Melden Sie sich an, um mehr in der App zu machen',
            subtitle: 'Melden Sie sich an oder registrieren Sie sich, um Tabellengrenzen zu erhöhen, Diagramme zu speichern und weitere Funktionen freizuschalten.'
        },
        m_new_diagram: {
            title: 'Neues Diagramm',
            subtitle: 'Datenbank-Engine auswählen',
            open_diagram: 'Diagramm öffnen',
            create_diagram: 'Diagramm erstellen',
            no_workspace: 'Erstellen Sie zuerst einen Arbeitsbereich, um ein Diagramm zu starten.',
            build_something_new: 'Lassen Sie uns etwas Neues erstellen',
            create_diagram_section: 'Diagramm erstellen',
            clone_template_btn: 'Vorlage duplizieren',
        },
        m_diagram_name: {
            enter_new_name: 'Neuen Diagrammnamen eingeben',
        },
        m_diagram_clone: {
            header: 'Diagramm duplizieren',
            copy_of_title: 'Kopie von {{title}}',
        },
        m_diagram_rename: {
            header: 'Diagramm umbenennen',
        },
        m_template_clone: {
            header: 'Diagramm aus Vorlage erstellen',
        },
        m_diagram_delete: {
            header: 'Diagramm löschen',
            desc_prefix: 'Diagramm wird gelöscht: ',
        },
        m_diagram_archive: {
            header: 'Diagramm archivieren',
            desc_prefix: 'Diagramm wird archiviert: ',
        },
        m_diagram_restore: {
            header: 'Diagramm wiederherstellen',
            desc_prefix: 'Diagramm wird wiederhergestellt: ',
        },
        m_diagram_import: {
            sql_name: 'SQL-Code importieren',
            dbml_name: 'DBML-Code importieren',
            // NOTE: en.js flags this placeholder copy as mismatched content (reads like
            // feedback-modal copy, not an SQL/DBML paste prompt). Kept verbatim in
            // translation since fixing the copy is a product call, not a translation one.
            placeholder: 'Wir würden uns über Ihre Gedanken freuen!',
        },
        m_diagram_not_found: {
            header: 'Diagramm nicht gefunden',
            desc: 'Wir konnten das gesuchte Diagramm nicht finden.',
            back_to_app: 'Zurück zur App',
        },
        m_diagram_share: {
            header: 'Diagramm teilen – {{title}}',
            owner_only_invite: 'Nur der Eigentümer kann neue Mitglieder einladen',
            invited_to_workspace: 'Zum Arbeitsbereich eingeladen',
            you: 'Sie',
            email_placeholder: 'E-Mail eingeben',
            email_already_in_list: 'E-Mail ist bereits in der Liste',
            will_be_invited_to_workspace: 'wird zum Arbeitsbereich eingeladen',
        },
        m_invite_people: {
            header: 'Zum Arbeitsbereich einladen',
        },
        m_invite_revoke: {
            header: 'Einladung entfernen',
            desc_prefix: 'Einladung entfernen für ',
            desc_suffix: 'Die Einladung funktioniert danach nicht mehr.',
        },
        m_member_remove: {
            header: 'Mitglied entfernen',
            desc_prefix: 'Entfernen von ',
            desc_suffix: ' aus diesem Arbeitsbereich? Der Zugriff geht verloren.',
        },
        m_template_details: {
            preview: 'Vorschau',
            use_template: 'Vorlage verwenden',
        },
        m_workspace_create: {
            header: 'Neuen Arbeitsbereich erstellen',
            name_label: 'Name',
            setup_config_label: 'Konfiguration einrichten',
            setup_config_value: 'Leerer Arbeitsbereich',
            template_structure_label: 'Vorlage/Struktur',
            template_structure_value: 'Struktur vorladen',
            placeholder: 'Namen des Arbeitsbereichs eingeben',
            create_button: 'Arbeitsbereich erstellen',
            creating: 'Ihr Arbeitsbereich wird erstellt...',
        },
        m_workspace_delete: {
            header: 'Arbeitsbereich löschen',
            desc_prefix: 'Wird endgültig gelöscht: ',
            confirm_prefix: 'Geben Sie ',
            confirm_suffix: ' ein, um zu bestätigen.',
        },
        m_workspace_leave: {
            header: 'Arbeitsbereich verlassen',
            desc_prefix: 'Dadurch werden Sie aus ',
            desc_suffix: ' entfernt. Sie müssen erneut eingeladen werden, um wieder beizutreten.',
        },
        m_workspace_menu: {
            manage_members: 'Mitglieder verwalten',
            switch_workspace: 'Arbeitsbereich wechseln',
            workspaces_label: 'Arbeitsbereiche',
            create_workspace: 'Arbeitsbereich erstellen...',
            switching: 'Wird gewechselt',
        },
        m_profile_menu: {
            profile: 'Profil',
            onboarding: 'Erste Schritte',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Bringen Sie Ihre Zusammenarbeit auf das nächste Level', description: 'Upgraden Sie, um weitere Freigabe-Rollen wie Admin, Bearbeiter, Kommentator und Betrachter freizuschalten.' },
            workspaces: { title: 'Sie wachsen schnell!', description: 'Upgraden Sie, um mehr Arbeitsbereiche für Ihre Projekte und Teams zu erstellen und zu verwalten.' },
            workspaces_canvas: { title: 'Erweitern Sie Ihre Arbeitsbereiche', description: 'Upgraden Sie, um mehr Arbeitsbereiche für Ihre Projekte und Teams zu erstellen und zu verwalten.' },
            members: { title: 'Skalieren Sie Ihre Zusammenarbeit', description: 'Upgraden Sie, um mehr Mitglieder in Ihren Arbeitsbereich zu holen und effektiver zusammenzuarbeiten.' },
            diagrams: { title: 'Sie wachsen schnell!', description: 'Upgraden Sie, um mehr Diagramme zu erstellen und Ihre Projekte mit Zuversicht auszubauen.' },
            tables: { title: 'Grenzenlos erstellen', description: 'Upgraden Sie, um weitere Tabellen hinzuzufügen und größere, detailliertere Diagramme zu erstellen.' },
            columns: { title: 'Grenzenlos erstellen', description: 'Upgraden Sie, um weitere Spalten hinzuzufügen und größere, detailliertere Diagramme zu erstellen.' },
            notes: { title: 'Grenzenlos erstellen', description: 'Upgraden Sie, um weitere Notizen hinzuzufügen und größere, detailliertere Diagramme zu erstellen.' },
            areas: { title: 'Grenzenlos erstellen', description: 'Upgraden Sie, um weitere Bereiche hinzuzufügen und größere, detailliertere Diagramme zu erstellen.' },
            pens: { title: 'Grenzenlos erstellen', description: 'Upgraden Sie, um weitere Zeichnungen hinzuzufügen und größere, detailliertere Diagramme zu erstellen.' },
            default_title: 'Bringen Sie Ihre Zusammenarbeit auf das nächste Level',
            default_title_canvas: 'Steigern Sie Ihre Leistung',
        },
        m_pricing_plans: {
            title: 'Plan upgraden',
            subtitle: 'Sie können Ihren Plan jederzeit später upgraden oder herabstufen',
            monthly: 'Monatlich',
            annually: 'Jährlich',
            billed_annually: 'Jährliche Abrechnung',
            billed_monthly: 'Monatliche Abrechnung',
            free_for_everyone: 'Kostenlos für alle',
            current_plan: 'Aktueller Plan',
            will_be_available_soon: 'Bald verfügbar',
            price_period_user_month: '/Nutzer/Monat',
            plan_free: {
                name: 'Kostenlos',
                button: 'Plan ändern',
                feature_realtime: 'Echtzeit-Zusammenarbeit',
                feature_members: '4 Mitglieder / Arbeitsbereich',
                feature_diagrams: '4 Diagramme / Arbeitsbereich',
                feature_tables: '40 Tabellen / Diagramm',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Alle Funktionen von Kostenlos +',
                feature_members: 'Unbegrenzte Mitglieder',
                feature_diagrams: 'Unbegrenzte Diagramme',
                feature_tables: 'Unbegrenzte Tabellen',
                feature_history: 'Versionsverlauf',
                feature_admin_roles: 'Admin-Rollen',
            },
        },
        sidebar: {
            new: 'Neu',
            pinned_diagrams: 'Angepinnte Diagramme',
            pin_hint: 'Pinnen Sie Diagramme an, um sie hier zu sehen',
            expand_sidebar: 'Seitenleiste erweitern',
            home_aria: 'DB Design Startseite',
            open_menu: 'Menü öffnen',
            close_menu: 'Menü schließen',
            sidebar_menu_aria: 'Seitenleistenmenü',
            plan_suffix: 'Plan',
            diagram_options: 'Diagrammoptionen',
            pin: 'Anpinnen',
            unpin: 'Lösen',
            edit_details: 'Details bearbeiten',
            see_details: 'Details anzeigen',
            invite_people: 'Personen einladen',
            collapse_sidebar: 'Seitenleiste einklappen',
            close_sidebar: 'Seitenleiste schließen',
            open_sidebar: 'Seitenleiste öffnen',
            open_new_tab: 'In neuem Tab öffnen',
        },
        focus_controls: {
            show_top: 'Obere Steuerelemente anzeigen',
            hide_top: 'Obere Steuerelemente ausblenden',
            show_left: 'Linke Steuerelemente anzeigen',
            hide_left: 'Linke Steuerelemente ausblenden',
        },
        m_keyboard_shortcuts: {
            title: 'Tastenkürzel',
            general: {
                title1: 'Allgemein',
                title2: '',
                items: {
                    new_diagram: 'Diagramm erstellen',
                    new_chat: 'Neuer Chat',
                    search: 'Schnellaktionen oder Suche',
                    preferences: 'Präferenzen',
                    settings: 'Einstellungen',
                    keyboard_shortcuts: 'Tastenkürzel',
                    toggle_sidebar: 'Seitenleiste umschalten',
                    toggle_theme: 'Design umschalten',
                },
            },
            ctrl_left: {
                title1: 'Bedienelemente',
                title2: '(Links)',
                items: {
                    mouse_sel: 'Mausauswahl / Handmodus',
                    table: 'Tabelle',
                    line: 'Linie',
                    area: 'Bereich',
                    note: 'Notiz',
                    comment: 'Kommentar',
                    pen: 'Stift',
                    undo: 'Rückgängig',
                    redo: 'Wiederholen'
                }
            },
            ctrl_top_left: {
                title1: 'Bedienelemente',
                title2: '(Oben links)',
                items: {
                    export_img: 'Bild exportieren',
                    search: 'Suchen',
                    editor_panel: 'Editorbereich',
                    zoom_to_fit: 'An Bildschirm anpassen',
                }
            },
            ctrl_bottom_right: {
                title1: 'Bedienelemente',
                title2: '(Unten rechts)',
                items: {
                    minimap: 'Minikarte',
                    full_screen: 'Vollbild',
                    zoom_in: 'Vergrößern',
                    zoom_out: 'Verkleinern',
                    zoom_100: 'Zoom auf 100 %'
                }
            },
            ctx_tab: {
                title1: 'Kontextmenü',
                title2: '(Tabelle)',
                items: {
                    dupl_tab: 'Tabelle duplizieren',
                    del_tab: 'Tabelle löschen'
                }
            },
            ctx_del_tab: {
                title1: 'Kontextmenü',
                title2: '(Tabelle löschen)',
                items: {
                    yes: 'Ja',
                    no: 'Nein'
                }
            },
            ctx_tab_col: {
                title1: 'Kontextmenü',
                title2: '(Tabellenspalte)',
                items: {
                    add_col_below: 'Neue Spalte darunter hinzufügen',
                    focus_col_above: 'Fokus auf die Spalte darüber',
                    focus_col_below: 'Fokus auf die Spalte darunter',
                    move_col_up: 'Spalte nach oben verschieben',
                    move_col_down: 'Spalte nach unten verschieben',
                    dupl_col: 'Spalte duplizieren',
                    del_col: 'Spalte löschen'
                }
            },
            ctx_line: {
                title1: 'Kontextmenü',
                title2: '(Linie)',
                items: {
                    del_line: 'Linie löschen'
                }
            },
            ctx_area: {
                title1: 'Kontextmenü',
                title2: '(Bereich)',
                items: {
                    dupl_area: 'Bereich duplizieren',
                    del_area: 'Bereich löschen'
                }
            },
            ctx_multi: {
                title1: 'Kontextmenü',
                title2: '(Mehrfachauswahl)',
                items: {
                    select_all: 'Alle Elemente auswählen',
                    create_area_for_select_els: 'Bereich für ausgewählte Elemente erstellen',
                    dupl_select_els: 'Ausgewählte Elemente duplizieren',
                    del_select_els: 'Ausgewählte Elemente löschen'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Mausauswahl',
                table: 'Tabelle',
                line: 'Linie',
                area: 'Bereich',
                note: 'Notiz',
                comment: 'Kommentar',
                pen: 'Stift',
                undo: 'Rückgängig',
                redo: 'Wiederholen'
            },
            ctrl_top_left: {
                home: 'Startseite',
                name: 'Diagramminformationen',
                editor: 'Editor',
                search: 'Suche',
                export: 'Exportoptionen',
                view_mode: 'Ansichtsmodus',
                zoom_to_fit: 'An Bildschirm anpassen',
                grid: 'Rasteransicht',
                history: 'Verlauf',
                main_menu: 'Hauptmenü',
                new_diagram: 'Neues Diagramm',
            },
            ctrl_top_right: {
                feature_req: 'Feature-Anfragen', // Funktionswunsch
                feedback: 'Feedback senden',
                sign_in: 'Anmelden',
                quick_share: 'Schnelles Teilen'
            },
            ctrl_bottom_right: {
                full_screen: 'Vollbild',
                minimap: 'Minikarte',
                zoom_out: 'Verkleinern',
                zoom_100: 'Zoom auf 100 %',
                zoom_in: 'Vergrößern',
                info: 'Informationen & Ressourcen'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Standard',
                        blue: 'Blau',
                        green: 'Grün',
                        red: 'Rot',
                        purple: 'Lila',
                        violet: 'Violett'
                    },
                    borders: {
                        none: 'Keine',
                        solid: 'Durchgezogen',
                        dashed: 'Gestrichelt',
                        dotted: 'Gepunktet'
                    },
                    color: 'Farbe',
                    border: 'Rahmen',
                    description: 'Beschreibung',
                    description_table_place: 'Beschreibung der Tabelle',
                    description_column_place: 'Beschreibung der Spalte',
                    description_line_place: 'Beschreibung der Linie',
                    description_note_place: 'Beschreibung der Notiz',
                    description_area_place: 'Beschreibung des Bereichs',
                    description_pen_place: 'Beschreibung des Pfads',
                    hide_menu: 'Menü ausblenden',
                    show_menu: 'Menü einblenden'
                },
                tab_col: {
                    add_col_below: 'Spalte darunter hinzufügen',
                    add_col_above: 'Spalte darüber hinzufügen',
                    key: 'Key',
                    keys: {
                        none: 'Keine',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Kein',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Spalte nach unten verschieben',
                    move_col_up: 'Spalte nach oben verschieben',
                    more_functions: 'Weitere Funktionen'
                },
                line: {
                    change_connects: 'Verbinder ändern',
                    connects: {
                        empty: 'Leer',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Elemente filtern'
                },
                note: {
                    link_placeholder: 'Link eingeben',
                    link_apply: 'Hinzufügen',
                    link_remove: 'Entfernen',
                    link_edit: 'Bearbeiten',
                    link_needs_selection: 'Text zum Verlinken auswählen',
                    bulleted_list: 'Liste',
                    numbered_list: 'Nummerierte Liste',
                    font_style: 'Schriftstil',
                    alignment: 'Ausrichtung',
                    align_left: 'Links',
                    align_center: 'Mitte',
                    align_right: 'Rechts',
                    link: 'Link',
                    monospace: 'Monospace',
                    bold: 'Fett',
                    italic: 'Kursiv',
                    underline: 'Unterstrichen',
                    strikethrough: 'Durchgestrichen',
                },
                multi: {
                    filter: 'Auswahl filtern',
                    create_area: 'Bereich erstellen'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Vollständig',      // коротка альтернатива: 'Komplett'
            keys_only: 'Nur Schlüssel',
            names_only: 'Nur Namen'
        },
        dropdown_ctrl_grid: {
            none: 'Kein',
            lines: 'Linien',
            dots: 'Punkte',
        },
        dropdown_ctrl_export: {
            export_img: 'Bild exportieren',
            export_code: 'SQL-Code exportieren'
        },
        dropdown_ctrl_settings: {
            back_home: 'Zurück zur Startseite',
            sign_in: 'Anmelden',
            preferences: 'Präferenzen',
            new_project: 'Neues Projekt',
            import_diagram: 'Diagramm importieren',
            duplicate_diagram: 'Diagramm duplizieren',
            keyboard_shortcuts: 'Tastenkürzel',
            languages: 'Sprachen',
            view: 'Ansicht',
            upgrade_plan: 'Tarif upgraden',
            language: 'Sprache',
            mouse_trackpad: 'Maus oder Trackpad',
            background_color: 'Hintergrundfarbe',
            grid_layout: 'Rasterlayout',
            view_mode: 'Ansichtsmodus',
            show_align_lines: 'Ausrichtungslinien anzeigen',
            show_members_cursors: 'Cursor der Mitglieder anzeigen',
            show_comments: 'Kommentare anzeigen',
            undo_redo_controls: 'Rückgängig/Wiederholen-Steuerung',
            show_scrollbars: 'Bildlaufleisten anzeigen',
            opt_auto: 'Automatisch',
            opt_trackpad: 'Trackpad',
            opt_mouse: 'Maus',
            opt_default: 'Dunkel (Standard)',
            opt_gray: 'Grau',
            opt_blue: 'Blau',
            opt_purple: 'Lila',
            opt_violet: 'Violett',
            opt_green: 'Grün',
            opt_red: 'Rot',
            opt_yellow: 'Gelb',
            opt_dots: 'Punkte',
            opt_lines: 'Linien',
            opt_none: 'Kein',
            opt_full: 'Vollständig',
            opt_keys: 'Schlüssel',
            opt_names: 'Namen',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Feedback',
            keyboard_shortcuts: 'Tastenkürzel',
            languages: 'Sprachen',
            homepage: 'Startseite'
        },
        n: {
            default: 'Wird geladen…',
            file_ready_to_download: 'Die Datei ist zum Herunterladen bereit',
            code_copied: 'Der Code wurde kopiert',
            link_copied: 'Der Link wurde kopiert',
            username_copied: 'Benutzername in die Zwischenablage kopiert',
            email_copied: 'E-Mail in die Zwischenablage kopiert',
            please_enter_message: 'Bitte geben Sie eine Nachricht ein',
            invalid_email: 'Die E-Mail-Adresse ist ungültig',
            note_link_unsupported_protocol: 'Linktyp nicht unterstützt. Verwenden Sie https, http, mailto.',
            something_wrong_contact: 'Etwas ist schiefgelaufen. Bitte laden Sie die Seite neu oder kontaktieren Sie uns.',
            something_wrong: 'Etwas ist schiefgelaufen. Bitte laden Sie die Seite neu.',
            sending: 'Senden…',
            request_sent: 'Die Anfrage wurde gesendet. Vielen Dank!',

            please_enter_email: 'E-Mail-Adresse eingeben',
            changing: 'Wird geändert...',
            role_changed: 'Rolle geändert',
            removing: 'Wird entfernt...',
            member_removed: 'Mitglied entfernt',
            inviting: 'Wird eingeladen...',
            invite_sent: 'Einladung gesendet',
            added_to_diagram: 'Zum Diagramm hinzugefügt',
            invite_removed: 'Einladung entfernt',
            role_not_allowed_on_plan: 'Diese Rolle ist in Ihrem Plan nicht verfügbar. Upgraden Sie, um sie zuzuweisen.',
            already_diagram_member: 'Diese Person hat bereits Zugriff auf das Diagramm.',
            cannot_invite_to_workspace: 'Bitten Sie einen Arbeitsbereich-Admin, diese Person zum Arbeitsbereich einzuladen.',
            saving: 'Wird gespeichert...',
            saved: 'Gespeichert',
            diagram_renamed: 'Diagramm umbenannt',
            diagram_updated: 'Diagramm aktualisiert',
            duplicating: 'Wird dupliziert...',
            diagram_duplicated: 'Diagramm dupliziert',
            deleting: 'Wird gelöscht...',
            diagram_archived: 'Diagramm archiviert',
            diagram_deleted: 'Diagramm gelöscht',
            restoring: 'Wird wiederhergestellt...',
            diagram_restored: 'Diagramm wiederhergestellt',
            diagram_pinned: 'Diagramm angepinnt',
            diagram_unpinned: 'Diagramm nicht mehr angepinnt',
            creating: 'Wird erstellt...',
            diagram_created: 'Diagramm erstellt',
            forbidden: 'Sie haben keinen Zugriff darauf.',
            invite_already_pending: 'This person already has a pending invitation.',
            already_member: 'Bereits Mitglied des Arbeitsbereichs',
            cannot_invite_self: 'Sie können sich nicht selbst einladen',
            workspace_not_found: 'Workspace not found. Refresh the page and try again.',
            diagram_not_found: 'Diagramm nicht gefunden.',
            has_diagram_members: 'Das Diagramm hat aktive Mitglieder',
            seat_limit_reached: 'Sie haben das Platzlimit Ihres Plans erreicht. Upgraden Sie, um weitere Personen einzuladen.',
            feature_not_in_plan: 'Diese Funktion ist in Ihrem aktuellen Plan nicht enthalten.',
            subscription_expired: 'Ihr Abonnement ist abgelaufen. Verlängern Sie es, um dies weiter zu nutzen.',
            subscription_inactive: 'Ihr Abonnement ist inaktiv. Bitte aktualisieren Sie Ihre Zahlungsdaten.',
            plan_limit_generic: 'Ihr Plan erlaubt diese Aktion nicht. Upgraden Sie, um fortzufahren.',

            // Auth / profile
            session_expired: 'Ihre Sitzung ist abgelaufen — bitte melden Sie sich erneut an.',
            profile_updated: 'Profil aktualisiert',
            profile_update_failed: 'Profil konnte nicht aktualisiert werden.',
            account_delete_failed: 'Konto konnte nicht gelöscht werden.',

            // Preferences
            couldnt_save: 'Änderungen konnten nicht gespeichert werden',
            try_again: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',

            // Workspace
            not_workspace_member: 'Sie sind kein Mitglied dieses Arbeitsbereichs.',
            workspace_switch_failed: 'Arbeitsbereich konnte nicht gewechselt werden. Bitte versuchen Sie es erneut.',
            workspace_create_failed: 'Arbeitsbereich konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
            invalid_workspace_name: 'Ungültiger Arbeitsbereichsname',
            workspace_updated: 'Arbeitsbereich aktualisiert',
            workspace_update_failed: 'Arbeitsbereich konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
            last_owner_cannot_leave: 'Sie sind der einzige Eigentümer. Machen Sie jemand anderen zum Eigentümer oder löschen Sie den Arbeitsbereich, bevor Sie ihn verlassen.',
            workspace_leave_failed: 'Arbeitsbereich konnte nicht verlassen werden. Bitte versuchen Sie es erneut.',
            workspace_delete_forbidden: 'Nur der Eigentümer des Arbeitsbereichs kann diesen Arbeitsbereich löschen.',
            workspace_has_active_billing: 'Kündigen Sie das Abonnement dieses Arbeitsbereichs, bevor Sie ihn löschen.',
            workspace_deleted: 'Arbeitsbereich gelöscht',
            workspace_delete_failed: 'Arbeitsbereich konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
            member_remove_forbidden: 'Sie haben keine Berechtigung, dieses Mitglied zu entfernen.',
            member_remove_failed: 'Mitglied konnte nicht entfernt werden. Bitte versuchen Sie es erneut.',
            cannot_remove_self: 'Verwenden Sie „Arbeitsbereich verlassen“, um sich selbst zu entfernen.',
            cannot_remove_last_owner: 'Ein Arbeitsbereich muss immer einen Eigentümer haben. Machen Sie zuerst jemand anderen zum Eigentümer.',
            invite_revoke_forbidden: 'Sie haben keine Berechtigung, diese Einladung zu widerrufen.',
            invite_revoke_failed: 'Einladung konnte nicht widerrufen werden. Bitte versuchen Sie es erneut.',
        },
        dashboard: {
            doc_title: 'Diagramme',
            filter_all: 'Alle',
            filter_mydiagrams: 'Meine Diagramme',
            filter_shared: 'Für mich freigegeben',
            filter_archived: 'Archiviert',
            empty_all: 'Keine Diagramme in "Alle Diagramme"',
            empty_mydiagrams: 'Keine Diagramme in "Meine Diagramme"',
            empty_shared: 'Keine Diagramme in "Für mich freigegeben"',
            empty_archived: 'Keine Diagramme in "Archiviert"',
            example_diagram_badge: 'Beispieldiagramm',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Zurück zur App',
                group_personal: 'Persönlich',
                group_organization: 'Organisation',
                billing: 'Abrechnung',
            },
            profile: {
                member_since: 'Mitglied seit {{date}}',
                general: 'Allgemein',
                email: 'E-Mail',
                full_name: 'Vollständiger Name',
                full_name_placeholder: 'Namen eingeben',
                account_protection: 'Kontoschutz',
                mfa_label: 'Multi-Faktor-Authentifizierung (MFA)',
                mfa_sub: 'Zusätzliche Sicherheitsebene für Ihr Konto · Demnächst verfügbar',
                mfa_enable: 'MFA aktivieren',
                mfa_soon_tooltip: 'Bald verfügbar',
                workspace_access: 'Arbeitsbereichszugriff',
                leave_workspace: 'Arbeitsbereich verlassen',
                leave_workspace_sub: 'Sich selbst aus dem Arbeitsbereich entfernen',
                leave_owner_tooltip: 'Übertragen Sie das Eigentum, bevor Sie den Arbeitsbereich verlassen',
            },
            workspace: {
                header: 'Arbeitsbereich',
                general: 'Allgemein',
                name_label: 'Name des Arbeitsbereichs',
                name_placeholder: 'Name des Arbeitsbereichs',
                stat_member_singular: 'Mitglied',
                stat_member_plural: 'Mitglieder',
                stat_team_singular: 'Team',
                stat_team_plural: 'Teams',
                members_section: 'Mitglieder',
                no_members: 'Keine Mitglieder',
                count_member_singular: 'Mitglied',
                count_member_plural: 'Mitglieder',
                view_members_btn: 'Mitglieder anzeigen',
                danger_zone: 'Gefahrenzone',
                delete_workspace: 'Arbeitsbereich löschen',
                delete_workspace_sub: 'Dadurch wird der Arbeitsbereich dauerhaft gelöscht',
                delete_owner_only_tooltip: 'Nur Eigentümer können Arbeitsbereiche löschen',
                delete_cancel_sub_tooltip: 'Kündigen Sie Ihr Abonnement, bevor Sie den Arbeitsbereich löschen',
            },
            members: {
                header: 'Mitglieder',
                col_name: 'Name',
                col_email: 'E-Mail',
                col_role: 'Rolle',
                col_joined: 'Beigetreten',
                active_members: 'Aktive Mitglieder',
                invited_section: 'Eingeladen',
                no_members: 'Noch keine Mitglieder.',
                options_aria: 'Optionen',
                leave_workspace_item: 'Arbeitsbereich verlassen...',
                remove_member_item: 'Mitglied entfernen...',
                remove_owner_only_tooltip: 'Nur Eigentümer können Mitglieder entfernen',
                remove_owner_row_tooltip: 'Der Eigentümer kann nicht aus dem Arbeitsbereich entfernt werden',
                remove_invite_item: 'Einladung entfernen...',
                role_invited_suffix: '{{role}} (Eingeladen)',
            },
            preferences: {
                section_general: 'Allgemein',
                section_diagram_defaults: 'Diagramm-Einstellungen',
                section_diagram_views: 'Diagrammansichten',
                section_notifications: 'Benachrichtigungen',
                theme_label: 'Oberflächenthema',
                theme_sub: 'Wählen Sie Ihr Oberflächen-Farbschema',
                theme_dark: 'Dunkel',
                theme_light: 'Hell',
                theme_system: 'System',
                language_sub: 'Wählen Sie Ihre Oberflächensprache',
                timezone_label: 'Zeitzone',
                timezone_sub: 'Wählen Sie Ihre Zeitzone',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawaii',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Pazifische Zeit',
                    denver: 'GMT-07:00 — Mountain-Zeit',
                    chicago: 'GMT-06:00 — Zentrale Zeit',
                    new_york: 'GMT-05:00 — Östliche Zeit',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Azoren',
                    london: 'GMT+00:00 — London',
                    paris: 'GMT+01:00 — Paris, Berlin',
                    kyiv: 'GMT+02:00 — Kyjiw, Athen',
                    istanbul: 'GMT+03:00 — Istanbul',
                    dubai: 'GMT+04:00 — Dubai',
                    karachi: 'GMT+05:00 — Karachi',
                    kolkata: 'GMT+05:30 — Indien',
                    dhaka: 'GMT+06:00 — Dhaka',
                    bangkok: 'GMT+07:00 — Bangkok, Jakarta',
                    shanghai: 'GMT+08:00 — Peking, Singapur',
                    tokyo: 'GMT+09:00 — Tokio, Seoul',
                    sydney: 'GMT+10:00 — Sydney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Wählen Sie die Navigationssteuerung für die Zeichenfläche',
                background_sub: 'Wählen Sie eine Hintergrundfarbe für die Zeichenfläche',
                grid_sub: 'Wählen Sie das Rasterlayout der Zeichenfläche',
                show_align_lines_sub: 'Linien beim Ausrichten von Objekten anzeigen',
                show_cursors_sub: 'Cursor anderer Mitarbeiter anzeigen',
                show_comments_sub: 'Kommentare auf der Zeichenfläche anzeigen',
                show_scrollbars_sub: 'Bildlaufleisten beim Navigieren auf der Zeichenfläche anzeigen',
                show_undo_redo_label: 'Rückgängig/Wiederholen-Steuerelemente anzeigen',
                show_undo_redo_sub: 'Steuerelemente zum Rückgängigmachen und Wiederholen von Änderungen anzeigen',
                notif_shared_label: 'Diagramm mit mir geteilt',
                notif_shared_sub: 'Wenn jemand ein Diagramm mit mir teilt',
                notif_mentions_label: 'Erwähnungen in Kommentaren',
                notif_mentions_sub: 'Wenn mich jemand in einem Kommentar @erwähnt',
                notif_updates_label: 'Produktneuigkeiten',
                notif_updates_sub: 'Monatliche Updates zu neuen Funktionen und Verbesserungen',
                show: 'Anzeigen',
                hide: 'Ausblenden',
                on: 'Ein',
                off: 'Aus',
            },
            billing: {
                header: 'Abrechnung',
                plan_free: 'Kostenloser Plan',
                status_current: 'Aktuell',
                no_renewal_needed: 'Keine Verlängerung erforderlich',
                payment_header: 'Zahlung',
                no_payments: 'Keine Zahlungen',
                invoices_header: 'Rechnungen',
                no_invoices: 'Keine Rechnungen',
            },
            usage: {
                doc_title: 'Nutzung',
                overview_title: 'Übersicht',
                resource_limits_title: 'Ressourcenlimits',
                label_diagrams: 'Diagramme',
                label_tables: 'Tabellen',
                label_areas: 'Bereiche',
                label_notes: 'Notizzettel',
                label_members: 'Mitglieder',
                label_tables_per_diagram: 'Tabellen / Diagramm',
                label_areas_per_diagram: 'Bereiche / Diagramm',
                label_notes_per_diagram: 'Notizen / Diagramm',
                need_more_title: 'Brauchen Sie mehr?',
                need_more_free: 'Upgraden Sie auf Basic für mehr Diagramme, Versionsverlauf und bevorzugten Support.',
                need_more_paid: 'Upgraden Sie auf Professional für unbegrenzte Diagramme, Plätze und erweiterte Funktionen.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Seite nicht gefunden',
                dont_have_access_to_diagram: 'Sie haben keinen Zugriff auf dieses Diagramm oder es existiert nicht mehr.',
                back_home: 'Zurück zur Startseite'
            },
            error: {
                title: 'Fehler',
                link_is_invalid: 'Dieser Link ist ungültig oder wurde falsch eingegeben.',
                something_wrong: 'Etwas ist schiefgelaufen.',
                back_home: 'Zurück zur Startseite',
                please_try_later: 'Bitte versuchen Sie es später erneut',
            },
            billing_success: {
                doc_title: 'Plan aktualisiert',
                heading: 'Zahlung erfolgreich',
                subtitle: 'Ihr Plan wurde erfolgreich aktualisiert.',
                cta: 'Design starten',
            },
            email_verified: {
                doc_title: 'E-Mail bestätigt',
            },
            forgot_password: {
                doc_title: 'Passwort vergessen',
            },
            password_updated: {
                doc_title: 'Passwort aktualisiert',
            },
            reset_password: {
                doc_title: 'Passwort zurücksetzen',
            },
            check_email: {
                doc_title: 'Überprüfen Sie Ihre E-Mails',
            },
            sign_in: {
                doc_title: 'Anmelden bei {{product}}',
            },
            sign_up: {
                doc_title: 'Registrieren bei {{product}}',
            },
        },
    }
};

export const deMeta = {
    lang_origin: 'Deutsch',
    lang_eng: 'German',
    lang_code: 'de',
};
